
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { X } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LoginTab from "./auth/LoginTab";
import RegisterTab from "./auth/RegisterTab";
import ContactFooter from "./auth/ContactFooter";

interface LoginFormProps {
  onLoginSuccess?: () => void;
  onClose?: () => void;
}

const LoginForm = ({ onLoginSuccess, onClose }: LoginFormProps) => {
  const navigate = useNavigate();
  
  const handleLoginSuccess = () => {
    if (onLoginSuccess) onLoginSuccess();
    navigate("/dashboard");
  };

  return (
    <Card className="w-full max-w-md bg-black/30 backdrop-blur-lg border-primary/20 animate-fade-in relative">
      {onClose && (
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 z-50 p-1 rounded-sm text-primary hover:bg-black/20"
        >
          <X size={20} />
        </button>
      )}
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl text-center font-bold text-primary">
          7 GConect
        </CardTitle>
        <CardDescription className="text-center text-primary/70">
          Pristupite svom Stellar Portalu
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="login" className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-4">
            <TabsTrigger value="login">Prijava</TabsTrigger>
            <TabsTrigger value="register">Registracija</TabsTrigger>
          </TabsList>
          
          <TabsContent value="login">
            <LoginTab onLoginSuccess={handleLoginSuccess} />
          </TabsContent>
          
          <TabsContent value="register">
            <RegisterTab />
          </TabsContent>
        </Tabs>
      </CardContent>
      <CardFooter className="flex justify-center pb-4 pt-0">
        <ContactFooter />
      </CardFooter>
    </Card>
  );
};

export default LoginForm;
